(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["header"]) return;
  try {
    
  class StickyHeader extends HTMLElement {
    constructor() {
      super();
    }

    connectedCallback() {
      this.header = document.querySelector('.section-header');
      this.headerIsAlwaysSticky =
        this.getAttribute('data-sticky-type') === 'always' ||
        this.getAttribute('data-sticky-type') === 'reduce-logo-size';
      this.headerBounds = {};

      this.setHeaderHeight();

      window.matchMedia('(max-width: 990px)').addEventListener('change', this.setHeaderHeight.bind(this));

      if (this.headerIsAlwaysSticky) {
        this.header.classList.add('shopify-section-header-sticky');
      }

      this.currentScrollTop = 0;
      this.preventReveal = false;
      this.predictiveSearch = this.querySelector('predictive-search');

      this.onScrollHandler = this.onScroll.bind(this);
      this.hideHeaderOnScrollUp = () => (this.preventReveal = true);

      this.addEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.addEventListener('scroll', this.onScrollHandler, false);

      this.createObserver();
    }

    setHeaderHeight() {
      document.documentElement.style.setProperty('--header-height', `${this.header.offsetHeight}px`);
    }

    disconnectedCallback() {
      this.removeEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.removeEventListener('scroll', this.onScrollHandler);
    }

    createObserver() {
      let observer = new IntersectionObserver((entries, observer) => {
        this.headerBounds = entries[0].intersectionRect;
        observer.disconnect();
      });

      observer.observe(this.header);
    }

    onScroll() {
      const scrollTop = window.pageYOffset || document.documentElement.scrollTop;

      if (this.predictiveSearch && this.predictiveSearch.isOpen) return;

      if (scrollTop > this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (this.preventHide) return;
        requestAnimationFrame(this.hide.bind(this));
      } else if (scrollTop < this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (!this.preventReveal) {
          requestAnimationFrame(this.reveal.bind(this));
        } else {
          window.clearTimeout(this.isScrolling);

          this.isScrolling = setTimeout(() => {
            this.preventReveal = false;
          }, 66);

          requestAnimationFrame(this.hide.bind(this));
        }
      } else if (scrollTop <= this.headerBounds.top) {
        this.header.classList.remove('scrolled-past-header');
        requestAnimationFrame(this.reset.bind(this));
      }

      this.currentScrollTop = scrollTop;
    }

    hide() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-hidden', 'shopify-section-header-sticky');
      this.closeMenuDisclosure();
      this.closeSearchModal();
    }

    reveal() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-sticky', 'animate');
      this.header.classList.remove('shopify-section-header-hidden');
    }

    reset() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.remove('shopify-section-header-hidden', 'shopify-section-header-sticky', 'animate');
    }

    closeMenuDisclosure() {
      this.disclosures = this.disclosures || this.header.querySelectorAll('header-menu');
      this.disclosures.forEach((disclosure) => disclosure.close());
    }

    closeSearchModal() {
      this.searchModal = this.searchModal || this.header.querySelector('details-modal');
      this.searchModal.close(false);
    }
  }

  customElements.define('sticky-header', StickyHeader);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["steps"] && !Shopify.designMode) return;
  try {
    
  (function () {
    function initStepsScroll(root) {
      var wrappers = root.querySelectorAll('[data-steps-scroll-wrapper]');

      wrappers.forEach(function (wrapper) {
        var scrollar = wrapper.querySelector('[data-steps-scrollar]');
        var prevBtn = wrapper.querySelector('[data-steps-nav="prev"]');
        var nextBtn = wrapper.querySelector('[data-steps-nav="next"]');

        if (!scrollar || !prevBtn || !nextBtn) return;

        function updateOverflowState() {
          var hasOverflow = scrollar.scrollWidth > scrollar.clientWidth + 1;
          wrapper.classList.toggle('has-overflow', hasOverflow);
        }

        function updateButtonState() {
          var maxScroll = scrollar.scrollWidth - scrollar.clientWidth;
          prevBtn.disabled = scrollar.scrollLeft <= 0;
          nextBtn.disabled = scrollar.scrollLeft >= maxScroll - 1;
        }

        function scrollByStep(direction) {
          var firstItem = scrollar.querySelector('.custom_steps_grid_item');
          var amount = firstItem ? firstItem.offsetWidth : 220;
          scrollar.scrollBy({ left: direction * amount, behavior: 'smooth' });
        }

        prevBtn.addEventListener('click', function () {
          scrollByStep(-1);
        });

        nextBtn.addEventListener('click', function () {
          scrollByStep(1);
        });

        scrollar.addEventListener('scroll', updateButtonState);
        window.addEventListener('resize', function () {
          updateOverflowState();
          updateButtonState();
        });

        updateOverflowState();
        updateButtonState();
      });
    }

    document.addEventListener('DOMContentLoaded', function () {
      initStepsScroll(document);
    });

    document.addEventListener('shopify:section:load', function (event) {
      initStepsScroll(event.target);
    });
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["video-with-usp"] && !Shopify.designMode) return;
  try {
    
  (function () {
    function initVideoUsp(root) {
      var wrappers = root.querySelectorAll('[data-video-usp]');

      wrappers.forEach(function (wrapper) {
        var video = wrapper.querySelector('video');
        var toggleBtn = wrapper.querySelector('[data-video-toggle]');

        if (!video || !toggleBtn) return;

        function toggleVideo() {
          video.play();
        }

        // button click toggles play/pause
        toggleBtn.addEventListener('click', toggleVideo);

        // clicking the video itself also toggles play/pause
        // (icon is hidden while playing, so this is how users pause)
        video.addEventListener('click', toggleVideo);

        video.addEventListener('play', function () {
          wrapper.classList.add('is_playing');
          video.setAttribute('controls', 'controls');
          toggleBtn.setAttribute('aria-label', 'Pause video');
        });

        video.addEventListener('pause', function () {
          wrapper.classList.remove('is_playing');
          video.removeAttribute('controls');
          toggleBtn.setAttribute('aria-label', 'Play video');
        });

        video.addEventListener('ended', function () {
          wrapper.classList.remove('is_playing');
          video.removeAttribute('controls');
          toggleBtn.setAttribute('aria-label', 'Play video');
        });
      });
    }

    document.addEventListener('DOMContentLoaded', function () {
      initVideoUsp(document);
    });

    document.addEventListener('shopify:section:load', function (event) {
      initVideoUsp(event.target);
    });
  })();

  } catch(e) { console.error(e); }
})();
})();
